"use client";

import { ChevronRight } from "lucide-react";
import { useState } from "react";
import { Paragraph } from "~/components/ui/Typography";

export function FaqItem({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-[14px] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] px-5 py-4 transition-all hover:border-[color:var(--color-accent)] hover:shadow-sm">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center justify-between gap-4 text-left"
        aria-expanded={isOpen}
      >
        <div className="text-[14px] font-semibold text-[color:var(--color-body)]">
          {question}
        </div>
        <ChevronRight
          size={16}
          className={`flex-shrink-0 text-[color:var(--color-muted)] transition-transform duration-200 ${
            isOpen ? "rotate-90" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="animate-fade-up pb-4 pt-1">
          <Paragraph className="text-[13px] leading-relaxed text-[color:var(--color-secondary)]">
            {answer}
          </Paragraph>
        </div>
      )}
    </div>
  );
}
